import useHbaw from "./useHbaw";

const useAdminName = () => {
  // Keep the code to make it easier for us to differentiate between HBAW and HBAS admin names  
  // const { isHbaw } = useHbaw();
  // if (isHbaw) {
  //   return "Organizer";
  // }

  return "Admin";
};

export default useAdminName;
